<ap-section-header>
  <ap-section-header-grid
    [caption]="'Global__Overview_Import'"
    [iconId]="'ap-basedata-icon'"
    [filterPlaceholder]="'Global_Filter'"
    [filterTooltip]="'filterTooltip'"
    [createText]="'Global__New'"
    (search)="searchIn($event)"
  ></ap-section-header-grid>
</ap-section-header>
<div class="ap-tabstrip-small">
  <kendo-tabstrip (tabSelect)="selectTab($event)">
    <kendo-tabstrip-tab [selected]="true">
      <ng-template kendoTabTitle>
        <ap-responsive-text key="LabsFiles" class="ap-tabstrip-header"></ap-responsive-text>
      </ng-template>
      <ng-template kendoTabContent>
        <ap-lab-result-files-overview></ap-lab-result-files-overview>
      </ng-template>
    </kendo-tabstrip-tab>
    <kendo-tabstrip-tab>
      <ng-template kendoTabTitle>
        <ap-responsive-text key="Global__Logfiles" class="ap-tabstrip-header"></ap-responsive-text>
      </ng-template>
      <ng-template kendoTabContent>
        <ap-logfile-files-overview></ap-logfile-files-overview>
      </ng-template>
    </kendo-tabstrip-tab>
  </kendo-tabstrip>
</div>
